import styled from "styled-components";
import { P2, P3 } from "./Typography";
import moment from "moment";
import { Container, Attribute } from "./Attribute";
import { FaTimesCircle } from "react-icons/fa";
import useFileMeta from "./useFileMeta";

// export const Container = styled.div`
//     border-top: 2px solid #d9d9d9;
//     padding: 1rem 0;
//     display: flex;
//     flex-direction: column;
//     gap: 1rem;
// `

export const DailyReportAttributes = ({ report }) => {
    const meta = useFileMeta(report?.pdfKey);
    return (
        <Container>
            <P3>Report Information</P3>
            <Attribute>
                <P2>Customer</P2>
                {report?.customer?.name ?? report?.customerName}
            </Attribute>
            {
                report?.type === 'INSPECTION' &&
                <Attribute>
                    <P2>Address</P2>
                    {report?.address}
                </Attribute>
            }
            <Attribute>
                <P2>Date Submitted</P2>
                {moment(report?.submissionDate).format("YYYY-MM-DD [at] h:mm A")}
            </Attribute>

            <Attribute>
                <P2>Submitted By</P2>
                <span>{report?.foreman?.active ? '' : <FaTimesCircle />}{report?.foreman?.name}</span>
            </Attribute>

            {
                report?.pdfKey &&
                <Attribute>
                    <P2>File Size</P2>
                    <span>{meta?.fileSize}</span>
                </Attribute>
            }

            {
                !report?.pdfKey &&
                <Attribute>
                    <P2>Status</P2>
                    <span>PDF generation in progress</span>
                </Attribute>
            }
        </Container>
    )
}